/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getHydratedTrackEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.TrackChirpService',
  rpcName: 'getHydratedTrack',
  auth: 'app',
  fingerprint: 'YWKCFoaDalNMdm7DUjXvh--ymnNyhEw2',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};